export default {
  'units': {
    'kilometers': 'Kilómetros',
    'meters': 'Metros',
    'miles': 'Millas'
  },
  'areUnits': {
    'sqKms': 'km²',
    'hectare': 'Hectárea',
    'sqMeters': 'm²'
  }
}
